import React from 'react';
import { Link } from 'react-router-dom';
import './PastorSos.css';

export default function PastorSos() {
  return (
    <div className="pastor-sos">
      <Link className="pastor-sos__button" to="/sos">SOSボタン</Link>
    </div>
  );
}
